var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 20 20",
    height: "48px",
    viewBox: "0 0 20 20",
    width: "48px",
    fill: "#6c757d",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 20,
    width: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.44,15.38C16.79,14.84,17,14.19,17,13.5c0-1.93-1.57-3.5-3.5-3.5S10,11.57,10,13.5s1.57,3.5,3.5,3.5 c0.69,0,1.34-0.21,1.88-0.56L17.94,19L19,17.94L16.44,15.38z M13.5,15.5c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S14.6,15.5,13.5,15.5z M17.78,2L19,2.87l-3.88,5.9h0C14.61,8.59,14.07,8.5,13.5,8.5L17.78,2z M13.5,8.5c-0.58,0-1.13,0.1-1.65,0.28l0,0l-0.78-1.1 l-3.41,5.36l-2.48-2.97l-2.96,4.81L1,14l4-6.5l2.5,3L11,5L13.5,8.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphBlack);
export default __webpack_public_path__ + "static/media/graph-black.13a0631ae4f579559d993cd5db41f3d7.svg";
export { ForwardRef as ReactComponent };